import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';

import { postRequest } from 'core/axios/axios';
import { makeUrl } from 'core/utils/utils';

import { subscriptionIntentSelector } from 'state/subscription/selectors';
import { PaymentIntentType } from 'state/subscription/reducer';

import { CircularProgressPage } from 'components/CircularProgressPage/CircularProgressPage';
import { PaymentForm } from 'components/PaymentForm/PaymentForm';

import { RedirectAfterPayment } from 'types';

import { Endpoint } from '../../../Endpoint';
import { RoutePath } from 'RoutePath';

const getRedirect = (paymentIntent: PaymentIntentType) => {
    switch (paymentIntent) {
        case PaymentIntentType.RESUME_ONLINE:
            return RedirectAfterPayment.SUBSCRIPTION_RESUMED_ONLINE_SHOP;
        case PaymentIntentType.RESUME_PRIORITY:
            return RedirectAfterPayment.SUBSCRIPTION_RESUMED_PRIORITY;
        case PaymentIntentType.CHANGE:
            return RedirectAfterPayment.PAYMENT_METHOD_CHANGED;
    }
};

export const VendorSubscriptionNewCard = () => {
    const paymentIntent = useSelector(subscriptionIntentSelector);
    const after = getRedirect(paymentIntent.intentType);
    const [confirmationToken, setConfirmationToken] = useState<string>(null);
    useEffect(() => {
        const url = makeUrl(Endpoint.VENDOR_SUBSCRIBE, {}, { subscriptionPlanId: paymentIntent.subscriptionPlanId });
        postRequest(url, {})
            .then(response => {
                setConfirmationToken(response.data.confirmationToken);
            })
            .catch();
    }, []);
    return confirmationToken ? (
        <Box m={2}>
            <PaymentForm
                confirmationToken={confirmationToken}
                returnUrl={RoutePath.VENDOR_MENU_SUBSCRIPTION + `?after=${after}`}
            />
        </Box>
    ) : (
        <CircularProgressPage />
    );
};
